export default __webpack_public_path__ + "static/dunman-logo-d5993e50d23cfc6b13e72d5fd3909a3b.png";